/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MeetingsNoShowFinalizeParams } from './meetingsNoShowFinalizeParams';

/**
 * Request model for meetings no-show finalize job
 */
export interface RunMeetingsNoShowFinalizeJobRequest {
  type: 'meetings_noshow_finalize';
  params: MeetingsNoShowFinalizeParams;
  allowOverlappingJobs?: boolean;
}
